var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraftEmployeesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 41.8335C36 38.888 32.4183 36.5002 28 36.5002C23.5817 36.5002 20 38.888 20 41.8335M36 33.8335H44M28 32.5002C25.0545 32.5002 22.6667 30.1123 22.6667 27.1668C22.6667 24.2213 25.0545 21.8335 28 21.8335C30.9455 21.8335 33.3333 24.2213 33.3333 27.1668C33.3333 30.1123 30.9455 32.5002 28 32.5002Z",
    stroke: "#667085",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftEmployeesIcon);
export default __webpack_public_path__ + "static/media/draftEmployeesIcon.f52a7ccca214c93c38e8bb0954b3d028.svg";
export { ForwardRef as ReactComponent };